import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24SortAsc = props => {
  return (
    <SvgIcon {...props}>
      <path d="M19 17H22L18 21L14 17H17V3H19V17ZM2 17H12V19H2V17ZM6 5V7H2V5H6ZM2 11H9V13H2V11Z" />
    </SvgIcon>
  );
};

export default SvgI24SortAsc;
